import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from 'utils/colors';

export const ContainerConteudo = styled.div`
  max-width: 1400;
  width: 100%;
  min-width: 300px;
`;

export const HeaderFiltro = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 655px) {
    flex-wrap: wrap;
  }
`;

export const FiltroDate = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;

  @media (max-width: 655px) {
    width: 100%;
  }
`;

export const LinkRedirect = styled(Link)`
  border-radius: 20px;
  height: 35px;
  border: 1px solid ${colors.verde};
  width: 250px;
  text-transform: uppercase;
  color: ${colors.verde};
  font-weight: 700;
  background-color: ${colors.branco};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${colors.branco};
    background-color: ${colors.verde};
  }
`;

export const ButtonOrcamento = styled.div`
  color: #f6f6f6;
  background-color: ${colors.verde};
  border: 1px solid ${colors.verde};
  width: 80px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  cursor: pointer;
  transition: ease-in-out 250ms;
  padding: 20px 60px;

  &:hover {
    background-color: ${colors.branco};
    color: ${colors.verde};
  }
`;
